﻿import { 
  leadsBasicCommunitySubmission, 
  leadsBasicPlanSubmission, 
  leadsBasicSpecSubmission, 
  leadsBasicListingSubmission 
} from 'constants/routes';

export const postSpecBrochureBasic = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },

    selector: (response) => response.text(),
  };

  fetch(leadsBasicSpecSubmission, requestObject);
};

export const postPlanBrochureBasic = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsBasicPlanSubmission, requestObject);
};

export const postCommunityBrochureBasic = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsBasicCommunitySubmission, requestObject);
};

export const postBasicListingBrochureBasic = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsBasicListingSubmission, requestObject);
};
